import { NotFoundError } from '../errors/ColumnErrors';
import { ERef, ESnapshotExists, ETransaction, exists } from '../types';

const getNotFoundError = (ref: ERef<any> | null | undefined) =>
  new NotFoundError(`Could not get document that does not exist: ${ref?.path}`);

/**
 * Get a snapshot from a ref ... for the discerning programmer who is tired of checking
 * exists() and throwing everywhere.
 */
export const getOrThrow = async <T>(
  ref?: ERef<T> | null,
  options: { transaction?: ETransaction } = {}
): Promise<ESnapshotExists<T>> => {
  if (options.transaction) {
    if (!ref) {
      throw new Error('No ref supplied');
    }
    const snap = await options.transaction.get(ref);
    if (!exists(snap)) {
      throw getNotFoundError(ref);
    }
    return snap;
  }

  const snap = await ref?.get();
  if (!exists(snap)) {
    throw getNotFoundError(ref);
  }
  return snap;
};

export const getOrThrowTransaction = async <T>(
  transaction: ETransaction,
  ref: ERef<T>
): Promise<ESnapshotExists<T>> => {
  const snap = await transaction.get(ref);

  if (!exists(snap)) {
    throw getNotFoundError(ref);
  }

  return snap;
};
